import * as sifarish from "./sifarish-policies"

export const sifarishPolicy = sifarish
